import React from 'react'
import styled from 'styled-components'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'

const StyledTitle = styled(Paragraph)`
  margin-bottom: ${convertUnit(16)};
`
const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: ${convertUnit(20)};
  gap: ${convertUnit(20)};
`
const StyledButton = styled(Button)`
  width: 100%;
`
const StyledModal = styled(Modal)`
  width: 100%;
  max-width: ${convertUnit(335)};
  padding: ${convertUnit(20)};
  text-align: center;
`

interface GiftShopTemplateUploadVerifyPriceModalProps {
  price: string
  visible: boolean
  onConfirm(): void
  toggleModal(): void
  onCancel?(): void
}
export default function GiftShopTemplateUploadVerifyPriceModal({
  price,
  visible,
  onConfirm,
  toggleModal,
  onCancel,
}: GiftShopTemplateUploadVerifyPriceModalProps) {
  const {translate} = useTranslation()
  return (
    <StyledModal
      visible={visible}
      onBackdropPress={() => {
        toggleModal()
        onCancel && onCancel()
      }}>
      <StyledTitle fontSize="xl" fontWeight="bold">
        {translate('giftShop:uploadPriceVerifyTitle')}
      </StyledTitle>
      <StyledTitle fontSize="l" fontWeight="bold" color="primary_5">
        {price}
      </StyledTitle>
      <Paragraph fontSize="l">
        {translate('giftShop:uploadPriceVerifyDesc')}
      </Paragraph>
      <StyledButtonContainer>
        <StyledButton
          label={translate('giftShop:uploadPriceZeroModalButtonCancel')}
          color="primary_5"
          backgroundColor="white_3"
          onClick={() => {
            toggleModal()
            onCancel && onCancel()
          }}
        />
        <StyledButton
          label={translate('global:continue')}
          onClick={onConfirm}
        />
      </StyledButtonContainer>
    </StyledModal>
  )
}
